import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpEventType,
} from '@angular/common/http';
import saveAs from 'file-saver';
import fetch from 'node-fetch';
import { Observable } from 'rxjs';
import { Configuration, User } from 'src/openapi';
import { CustomHttpParameterCodec } from 'src/openapi/encoder';

export class Global {

  public static get config() {
    return {
      // controls default attachments box expansion status in
      // classroom course, edition and day details page
      attachmentsBoxExpanded: true
    }
  }

  public static get menuRolesMap(): MenuRolesMap {
    const menuRolesMap: MenuRolesMap = {
      sections: [
        {
          name: 'admin',
          allowedRoles: ['admin', 'CO-ADM', 'CO-ADS', 'CO-AVI', 'CO-APB', 'CO-VIS', 'CO-SVI', 'CO-GCA', 'CO-GCA'],
          menu: [
            {
              name: 'education',
              menu: [
                {
                  name: 'paths-management',
                  preventRoles: ['CO-APB', 'CO-GCA'], // allow CO-AVI, Drupal doesn't
                  menu: [
                    {
                      name: 'paths',
                    },
                    {
                      name: 'expertises',
                    },
                  ],
                },
                {
                  name: 'classroom-courses-management',
                  menu: [
                    {
                      name: 'classroom-courses',
                    },
                    {
                      name: 'teachers',
                      preventRoles: ['CO-APB', 'CO-GCA'],
                    },
                    {
                      name: 'locations',
                      preventRoles: ['CO-AVI', 'CO-APB', 'CO-GCA'],
                    },
                    {
                      name: 'attachments',
                      preventRoles: ['CO-AVI', 'CO-GCA'],
                    },
                  ],
                },
                {
                  name: 'certifications-management',
                  preventRoles: ['CO-AVI', 'CO-VIS', 'CO-SVI', 'CO-APB', 'CO-GCA'],
                  menu: [
                    {
                      name: 'certifications',
                    },
                    {
                      name: 'external-certification-time',
                    },
                    {
                      name: 'external-certification-tests',
                    },
                    {
                      name: 'certifications-bonuses',
                    },
                  ],
                },
                {
                  name: 'final-reviews-management',
                  preventRoles: ['CO-AVI', 'CO-VIS', 'CO-SVI', 'CO-APB', 'CO-GCA'],
                  menu: [
                    {
                      name: 'final-reviews',
                    },
                    {
                      name: 'questions',
                    },
                    {
                      name: 'question-categories',
                    },
                  ],
                },
                {
                  name: 'satisfaction-quizzes-management',
                  preventRoles: ['CO-AVI', 'CO-VIS', 'CO-SVI', 'CO-APB', 'CO-GCA'],
                  menu: [
                    {
                      name: 'satisfaction-quizzes',
                    },
                    {
                      name: 'questions',
                    },
                  ],
                },
                {
                  name: 'online-courses-management',
                  preventRoles: ['CO-APB', 'CO-GCA'],
                  menu: [
                    {
                      name: 'online-courses',
                    },
                    {
                      name: 'academy',
                      preventRoles: ['CO-AVI', 'CO-VIS', 'CO-SVI'],
                    },
                    {
                      name: 'forum',
                    },
                    {
                      name: 'product-sheets',
                    },
                  ],
                },
                {
                  name: 'multicourses-management',
                  preventRoles: ['CO-AVI', 'CO-VIS', 'CO-SVI', 'CO-APB', 'CO-GCA'],
                  menu: [
                    {
                      name: 'multicourses',
                    },
                  ],
                },
                {
                  name: 'courses-catalogue-management',
                  preventRoles: ['CO-APB', 'CO-GCA'],
                  menu: [
                    {
                      name: 'courses-catalogue',
                    },
                  ],
                },
              ],
            },
            {
              name: 'documents',
              preventRoles: ['CO-VIS', 'CO-SVI', 'CO-APB'],
              menu: [
                {
                  name: 'attendance-registers',
                },
                {
                  name: 'certificates',
                },
                {
                  name: 'satisfaction-quizzes-archive',
                  preventRoles: ['CO-AVI'],
                },
                {
                  name: 'final-reviews-archive',
                  preventRoles: ['CO-AVI'],
                },
              ],
            },
            {
              name: 'consultants-management',
              preventRoles: ['CO-APB'],
              menu: [
                {
                  name: 'main-consultants',
                  preventRoles: ['CO-GCA'],
                  menu: [
                    {
                      name: 'consultants'
                    },
                    {
                      name: 'consultants-structure'
                    },
                    {
                      name: 'teachers',
                      preventRoles: ['CO-VIS', 'CO-SVI'],
                    },
                    {
                      name: 'exemptions',
                      preventRoles: ['CO-AVI', 'CO-VIS', 'CO-SVI'],
                    },
                  ]
                },
                {
                  name: 'report',
                  menu: [
                    {
                      name: 'courses',
                    },
                    {
                      name: 'certifications',
                      preventRoles: ['CO-SVI', 'CO-VIS', 'CO-GCA'],
                      menu: [
                        {
                          name: 'ivass',
                        },
                        {
                          name: 'mifid',
                        },
                        {
                          name: 'cp',
                        },
                      ],
                    },
                    {
                      name: 'quizzes',
                      preventRoles: ['CO-AVI', 'CO-SVI', 'CO-VIS', 'CO-GCA'],
                    },
                    {
                      name: 'product-sheets',
                      preventRoles: ['CO-GCA']
                    },
                    {
                      name: 'insurance-products',
                    },
                    {
                      name: 'other-reports',
                      preventRoles: ['CO-SVI', 'CO-VIS', 'CO-GCA'],
                      menu: [
                        {
                          name: 'impersonate',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: 'communication',
              preventRoles: ['CO-VIS', 'CO-SVI', 'CO-APB', 'CO-GCA'],
              menu: [
                {
                  name: 'news',
                  preventRoles: ['CO-AVI'],
                },
                {
                  name: 'alerts',
                },
                {
                  name: 'help',
                },
              ],
            },
            {
              name: 'media-library',
              preventRoles: ['CO-VIS', 'CO-SVI', 'CO-GCA'],
            },
          ],
        },
        {
          name: 'manager',
          allowedRoles: ['AM', 'DM', 'RM', 'GM'],
        },
        {
          name: 'student',
          allowedRoles: ['PB', 'TFA', 'CO-APB'],
        },
      ],
    };

    return menuRolesMap;
  }

  public static get isInMaintenanceMode(): boolean {
    // eslint-disable-next-line eqeqeq
    return localStorage.getItem('isInMaintenanceMode') == 'true';
  }
  public static set isInMaintenanceMode(newValue: boolean | null) {
    if (newValue === null) {
      localStorage.removeItem('isInMaintenanceMode');
    } else {
      localStorage.setItem('isInMaintenanceMode', newValue ? 'true' : 'false');
    }
  }

  public static get isLoggedInFromSSO(): boolean {
    // eslint-disable-next-line eqeqeq
    return localStorage.getItem('isLoggedInFromSSO') == 'true';
  }
  public static set isLoggedInFromSSO(newValue: boolean | null) {
    if (newValue === null) {
      localStorage.removeItem('isLoggedInFromSSO');
    } else {
      localStorage.setItem('isLoggedInFromSSO', newValue ? 'true' : 'false');
    }
  }

  public static get studentRoles(): string[] {
    return ['CO-PB', 'CO-TFA'];
  }

  public static get managerRoles(): string[] {
    return ['CO-AM', 'CO-DM', 'CO-RM', 'CO-GM'];
  }

  public static get adminRoles(): string[] {
    return ['admin', 'CO-ADS', 'CO-ADM', 'CO-VIS', 'CO-SVI', 'CO-AVI', 'CO-MNG', 'CO-APB', 'CO-GCA'];
  }

  public static isStudent(user: User): boolean {
    if (!user) return;
    const roles = [...this.studentRoles, ...this.managerRoles];
    const userRoles = user?.roles ?? [];
    return userRoles.some((role) => roles.includes(role));
  }

  public static isManager(user: User): boolean {
    if (!user) return;
    const roles = this.managerRoles;
    const userRoles = user?.roles ?? [];
    return userRoles.some((role) => roles.includes(role));
  }

  public static isAdmin(user: User): boolean {
    if (!user) return;
    const roles = this.adminRoles;
    const userRoles = user?.roles ?? [];
    return userRoles.some((role) => roles.includes(role));
  }

  public static checkRoles(user: User, roles: string[]): boolean {
    let authorized: boolean = false;
    if (roles.includes('admin')) {
      authorized = Global.isAdmin(user);
    }

    if (roles.includes('manager')) {
      authorized = Global.isManager(user);
    }

    if (roles.includes('student')) {
      authorized = Global.isStudent(user);
    }

    return authorized;
  }

  public static checkCampusRoles(user: User, campusRoles: string[], prevent: boolean = false): boolean {
    let authorized: boolean = prevent;

    if (!prevent) {
      if (user.roles?.some((role: string) => campusRoles.includes(role))) {
        authorized = true;
      }
    } else {
      if (user.roles?.every((role: string) => campusRoles.includes(role))) {
        authorized = false;
      }
    }

    return authorized;
  }
}

export class MenuRolesMap {
  sections: SectionMap[];
}

export class SectionMap {
  name: string;
  allowedRoles: string[];
  menu?: MenuMap[];
}

export class MenuMap {
  name: string;
  allowedRoles?: string[];
  preventRoles?: string[];
  menu?: MenuMap[];
}

export function dataURItoBlob(dataURI) {
  const byteString = atob(dataURI);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const int8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([int8Array], { type: 'application/octet-stream' });
  return blob;
}

export enum FileDownloadType {
  PDF = 'application/pdf',
  CSV = 'text/csv',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

function downloadFileObservable(
  httpClient: HttpClient,
  url: string,
  configuration: Configuration,
  token: string,
  type: FileDownloadType = FileDownloadType.XLSX,
  queryParams?: Map<string, string>
): Observable<HttpEvent<Blob>> {
  let queryParameters = new HttpParams({ encoder: configuration.encoder || new CustomHttpParameterCodec() });
  if (queryParams.size > 0) {
    queryParams.forEach((value, key) => {
      if (value !== undefined && value !== null) {
        queryParameters = addToHttpParams(queryParameters, <any>value, key);
      }
    });
  }

  return httpClient.get(`${configuration.basePath}/${url}`, {
    params: queryParameters,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: type,
    },
    withCredentials: undefined,
    observe: 'events',
    reportProgress: false,
  });
}

export function downloadAttachment(
  httpClient: HttpClient,
  url: string,
  configuration: Configuration,
  token: string,
  type: FileDownloadType,
  onSuccess?: () => void,
  onError?: (error) => void,
  queryParams?: Map<string, string>
) {
  downloadFileObservable(httpClient, url, configuration, token, type, queryParams).subscribe(
    (event) => {
      if (event?.type == HttpEventType.Response) {
        event.headers.keys();
        const contentDisposition = event.headers.get('Content-Disposition');
        const filenameRegex = /filename="(.+)"/;
        const filename = filenameRegex.exec(contentDisposition)[1];

        saveAs(event.body, filename);
        onSuccess();
      }
    },
    (error) => {
      onError(error);
    }
  );
}

function addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
  if (typeof value === 'object' && value instanceof Date === false) {
    httpParams = addToHttpParamsRecursive(httpParams, value);
  } else {
    httpParams = addToHttpParamsRecursive(httpParams, value, key);
  }
  return httpParams;
}

function addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
  if (value == null) {
    return httpParams;
  }

  if (typeof value === 'object') {
    if (Array.isArray(value)) {
      (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
    } else if (value instanceof Date) {
      if (key != null) {
        httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
      } else {
        throw Error('key may not be null if value is Date');
      }
    } else {
      Object.keys(value).forEach(
        (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
      );
    }
  } else if (key != null) {
    httpParams = httpParams.append(key, value);
  } else {
    throw Error('key may not be null if value is not object or array');
  }
  return httpParams;
}
